var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTristar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 24,
    viewBox: "0 0 96 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4411_15358)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1127 10.3623L16.3294 8.46924C15.9351 8.35093 15.6195 8.03543 15.5012 7.64105L13.6082 0.857769C13.2927 -0.285923 11.6364 -0.285923 11.3209 0.857769L9.42785 7.64105C9.30955 8.03543 8.99404 8.35093 8.59966 8.46924L1.85582 10.3623C0.712123 10.6778 0.712123 12.3341 1.85582 12.6497L8.63911 14.5427C9.03347 14.661 9.34898 14.9765 9.4673 15.3708L11.3603 22.1542C11.6758 23.2978 13.3322 23.2978 13.6477 22.1542L15.5407 15.3708C15.659 14.9765 15.9745 14.661 16.3689 14.5427L23.1522 12.6497C24.2564 12.2947 24.2564 10.6778 23.1127 10.3623Z",
    fill: "#D8B795"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4411_15358)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.1127 10.3623L52.3294 8.46924C51.9351 8.35093 51.6195 8.03543 51.5012 7.64105L49.6082 0.857769C49.2927 -0.285923 47.6364 -0.285923 47.3209 0.857769L45.4279 7.64105C45.3095 8.03543 44.994 8.35093 44.5997 8.46924L37.8558 10.3623C36.7121 10.6778 36.7121 12.3341 37.8558 12.6497L44.6391 14.5427C45.0335 14.661 45.349 14.9765 45.4673 15.3708L47.3603 22.1542C47.6758 23.2978 49.3322 23.2978 49.6477 22.1542L51.5407 15.3708C51.659 14.9765 51.9745 14.661 52.3689 14.5427L59.1522 12.6497C60.2564 12.2947 60.2564 10.6778 59.1127 10.3623Z",
    fill: "#D8B795"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_4411_15358)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.1127 10.3623L88.3294 8.46924C87.9351 8.35093 87.6195 8.03543 87.5012 7.64105L85.6082 0.857769C85.2927 -0.285923 83.6364 -0.285923 83.3209 0.857769L81.4279 7.64105C81.3095 8.03543 80.994 8.35093 80.5997 8.46924L73.8558 10.3623C72.7121 10.6778 72.7121 12.3341 73.8558 12.6497L80.6391 14.5427C81.0335 14.661 81.349 14.9765 81.4673 15.3708L83.3603 22.1542C83.6758 23.2978 85.3322 23.2978 85.6477 22.1542L87.5407 15.3708C87.659 14.9765 87.9745 14.661 88.3689 14.5427L95.1522 12.6497C96.2564 12.2947 96.2564 10.6778 95.1127 10.3623Z",
    fill: "#D8B795"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4411_15358"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4411_15358"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(36)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_4411_15358"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(72)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTristar);
export default __webpack_public_path__ + "static/media/tristar.b3b2a4bceaf010f0c7efbe945dee7bce.svg";
export { ForwardRef as ReactComponent };